// Bootstrap
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const MainFooter = ({ functions, status, dataTranslate }) => {
    return (
        <Modal.Footer
            className="w-100 d-flex flex-row align-items-center"
            dir="ltr"
            style={{ zIndex: '1001' }}
        >
            <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                <Button
                    onClick={(e) => {
                        functions.createShipment();
                    }}
                    // disabled={(!status.menuLoading || status.btnLoader) ? true : false}
                    disabled={( status.btnLoader) ? true : false}
                // disabled={status.btnLoader ? true : false}
                // className="disableBTN"
                >
                    {dataTranslate.popups.customerShipment_tab.records.add}
                </Button>

                <Button
                    onClick={() => {
                        functions.reset();
                        functions.onHide();
                        functions.setEXRData([]);
                        functions.setEXRLoading(false);
                    }}
                >
                    {dataTranslate.popups.customerShipment_tab.records.close}
                </Button>
            </div>
        </Modal.Footer>
    )
}

export default MainFooter;